import React from 'react';
import styled, { keyframes } from 'styled-components';
import prizeBtcCardPng from 'assets/images/lucky-draw/prize-btc-card.png';
import prizeGoatCardPng from 'assets/images/lucky-draw/prize-goat-card.png';
import prizeNftCardPng from 'assets/images/lucky-draw/prize-nft-card.png';
import prizeUsdtCardPng from 'assets/images/lucky-draw/prize-usdt-card.png';
import prizePointCardPng from 'assets/images/lucky-draw/prize-point-card.png';
import { ReactComponent as RightArrowIcon } from 'assets/images/lucky-draw/rightArrow.svg';
import { NETWORK_CONFIG } from 'constant';
import user from 'stores/user';

const PRIZE_IMAGE_MAP: Record<string, string> = {
    BTC: prizeBtcCardPng,
    USDT: prizeUsdtCardPng,
    GOATED: prizeGoatCardPng,
    NFT: prizeNftCardPng,
    Points: prizePointCardPng,
    POINTS: prizePointCardPng,
};

const Overlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.2);
    backdrop-filter: blur(2px);
    z-index: 999;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    box-sizing: border-box;

    @media (max-width: 768px) {
        padding: 10px;
        align-items: flex-start;
        padding-top: 50px;
    }

    @media (max-width: 480px) {
        padding: 5px;
        padding-top: 30px;
    }
`;

const PrizeCardContainer = styled.div`
    border-radius: 24px;
    padding: 40px;
    text-align: center;
    z-index: 1000;
    animation: ${keyframes`
        0% { 
            opacity: 0;
            transform: scale(0.5);
        }
        100% { 
            opacity: 1;
            transform: scale(1);
        }
    `} 0.5s ease-out;
    max-width: 95vw;
    max-height: 90vh;
    overflow-x: auto;
    overflow-y: auto;
    min-width: 320px;

    @media (max-width: 768px) {
        padding: 20px;
        border-radius: 16px;
        max-height: 85vh;
        padding-bottom: 40px;
    }

    @media (max-width: 480px) {
        padding: 15px;
        border-radius: 12px;
        max-height: 80vh;
        padding-bottom: 30px;
    }
`;

const PrizeCardsGrid = styled.div`
    display: flex;
    gap: 20px;
    justify-content: center;
    flex-wrap: wrap;
    margin-bottom: 30px;
    max-width: 100%;

    @media (max-width: 1200px) {
        gap: 15px;
    }

    @media (max-width: 768px) {
        gap: 12px;
    }

    @media (max-width: 480px) {
        gap: 8px;
    }
`;

const PrizeImage = styled.img`
    width: 160px;
    height: 220px;
    object-fit: contain;
    transition: transform 0.3s ease;
    flex-shrink: 0;

    &:hover {
        transform: scale(1.05);
    }
`;

const PrizeItem = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    position: relative;
`;

const PrizeName = styled.div`
    position: absolute;
    top: 36px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 14px;
    font-weight: 600;
    color: #fff;
    text-align: center;
    max-width: 160px;
    word-wrap: break-word;

    @media (max-width: 768px) {
        font-size: 12px;
        max-width: 140px;
    }

    @media (max-width: 480px) {
        font-size: 10px;
        max-width: 120px;
    }
`;

const PrizeQuantity = styled.div`
    position: absolute;
    bottom: 36px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 12px;
    font-weight: 500;
    color: #ffd700;
    text-align: center;
    background: rgba(255, 215, 0, 0.1);
    padding: 2px 8px;
    border-radius: 12px;
    border: 1px solid rgba(255, 215, 0, 0.3);

    @media (max-width: 768px) {
        font-size: 10px;
        padding: 1px 6px;
    }

    @media (max-width: 480px) {
        font-size: 8px;
        padding: 1px 4px;
    }
`;

const TotalDrawsBar = styled.div`
    background: rgba(16, 16, 16, 1);
    border-radius: 12px;
    padding: 20px;
    margin: 30px 0;
    display: flex;
    max-width: 483px;
    gap: 20px;
    align-items: center;
    justify-content: space-between;
    margin: 0 auto;
    border: 1px solid rgba(255, 255, 255, 0.1);

    @media (max-width: 768px) {
        position: fixed;
        bottom: 30%;
        left: 50%;
        transform: translateX(-50%);
        width: calc(100% - 40px);
        max-width: 400px;
        padding: 15px;
        margin: 0;
        flex-direction: column;
        gap: 15px;
        text-align: center;
        z-index: 1001;
        backdrop-filter: blur(10px);
    }

    @media (max-width: 480px) {
        bottom: 25%;
        width: calc(100% - 20px);
        max-width: 350px;
        padding: 12px;
        gap: 10px;
    }
`;

const TotalDrawsInfo = styled.div`
    display: flex;
    align-items: center;
    gap: 20px;
    color: white;
    font-size: 14px;
    @media (max-width: 480px) {
        gap: 8px;
        font-size: 12px;
    }
`;

const TotalDrawsText = styled.div`
    font-weight: 600;
    color: #f7931a;
`;

const ViewOnExplore = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    color: #999;
    cursor: pointer;
    transition: color 0.3s ease;

    &:hover {
        color: #f7931a;
    }
`;

const ShareButton = styled.button`
    background: linear-gradient(135deg, #6a0dad 0%, #f7931a 100%);
    border: none;
    border-radius: 8px;
    color: white;
    padding: 10px 20px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    gap: 8px;

    &:hover {
        transform: translateY(-1px);
        box-shadow: 0 4px 15px rgba(106, 13, 173, 0.3);
    }

    @media (max-width: 480px) {
        padding: 8px 16px;
        font-size: 12px;
    }
`;

interface Prize {
    id: number;
    name: string;
    amount?: string;
    decimal?: number;
    quantity?: number;
    key?: string;
}

interface PrizeCardProps {
    isVisible: boolean;
    prizes: Prize[];
    totalDraws: number;
    txHash?: string;
    onClose: () => void;
}

const PrizeCard: React.FC<PrizeCardProps> = ({ isVisible, prizes, totalDraws, txHash, onClose }) => {
    if (!isVisible) return null;

    const groupedPrizes = prizes;
    const shouldHideExplore =
        groupedPrizes.length > 0 && groupedPrizes.every((p) => ['GOATED', 'Points'].includes(p.name));

    const handleOpenOnExplore = () => {
        if (!user.chainId || !txHash) return;
        const explorerUrl = `${NETWORK_CONFIG[user.chainId].explore}/tx/${txHash}`;
        window.open(explorerUrl, '_blank');
    };
    const handleShareOnX = () => {
        const campaignUrl = `${origin}/lucky-draw`;
        const shareText = `Joined Today's Lucky Draw on One Piece Campaign 
🌊 Daily Tasks → Instant Rewards 
🎁 BTC, USDT, GOATED & Points more waiting for you! 
${campaignUrl}

#Web3 #Community #LuckyDraw`;
        const twitterUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}`;
        const winWidth = window.screen.width;
        const winHeight = window.screen.height;
        const left = (winWidth - 600) / 2;
        const top = (winHeight - 500) / 2;
        window.open(twitterUrl, 'Share to Twitter', `width=600,height=500,left=${left},top=${top}`);
    };

    return (
        <Overlay onClick={onClose}>
            <PrizeCardContainer onClick={(e) => e.stopPropagation()}>
                <PrizeCardsGrid>
                    {groupedPrizes.map((prize) => {
                        const image = prize.key ? PRIZE_IMAGE_MAP[prize.key] : undefined;

                        let displayName = prize.name;
                        if (prize.amount && prize.decimal) {
                            const amount = parseFloat(prize.amount);
                            const decimal = prize.decimal;
                            const adjustedAmount = amount / Math.pow(10, decimal);
                            displayName = `${adjustedAmount} ${prize.name}`;
                        } else if (prize.amount) {
                            displayName = `${prize.amount} ${prize.name}`;
                        }

                        return (
                            <PrizeItem key={prize.id}>
                                <PrizeImage src={image} alt={prize.name} />
                                <PrizeName>{displayName}</PrizeName>
                                <PrizeQuantity>x {prize.quantity}</PrizeQuantity>
                            </PrizeItem>
                        );
                    })}
                </PrizeCardsGrid>

                <TotalDrawsBar>
                    <TotalDrawsInfo>
                        <TotalDrawsText>Total Draws {totalDraws}</TotalDrawsText>
                        {!shouldHideExplore && txHash ? (
                            <ViewOnExplore onClick={handleOpenOnExplore}>
                                View on explore
                                <span style={{ fontSize: '12px', marginRight: '20px' }}>
                                    <RightArrowIcon />
                                </span>
                            </ViewOnExplore>
                        ) : null}
                    </TotalDrawsInfo>
                    <ShareButton onClick={handleShareOnX}>Share on X</ShareButton>
                </TotalDrawsBar>
            </PrizeCardContainer>
        </Overlay>
    );
};

export default PrizeCard;
